import { render, staticRenderFns } from "./OneColumn.vue?vue&type=template&id=2eb13522&scoped=true"
import script from "./OneColumn.vue?vue&type=script&lang=js"
export * from "./OneColumn.vue?vue&type=script&lang=js"
import style0 from "./OneColumn.vue?vue&type=style&index=0&id=2eb13522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb13522",
  null
  
)

export default component.exports